module.exports = __webpack_public_path__ + "media/wilhelm.5bc8ce0f.mp3";